var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.image != '')?_c('v-img',{attrs:{"src":_vm.image,"width":_vm.size + 'px'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }